export const SHOW_REPLIES_TOGGLE = "COMMENTS/SHOW_REPLIES_TOGGLE";

export default (state = { isShowingReplies: false }, { type, data }) => {
    switch (type) {
    case SHOW_REPLIES_TOGGLE:
        return { ...state, isShowingReplies: data.isNextStateShowingReplies };
    default: return state;
    }
};

export const toggleShowReplies = isNextStateShowingReplies => ({ type: SHOW_REPLIES_TOGGLE, data: { isNextStateShowingReplies } });
